<template>
  <div class="change-modal">
    <div class="change-modal__header flex justify-between items-center">
      <div class="text-slate-600 text-lg font-semibold">Change Subscription ID</div>
      <div type="div" class="cursor-pointer" @click="$emit('close')">
        <Icon icon-name="CloseIcon" />
      </div>
    </div>

    <div v-if="isConfirming" class="mt-6 space-y-4">
      <p class="text-lg font-semibold text-slate-800">
        Are you sure you want to Change Subscription ID?
      </p>
      <p class="text-sm text-slate-600">
        Changing the Subscription ID will update the tenant's current subscription reference
      </p>

      <div class="flex justify-between items-center gap-3">
        <button
          type="button"
          class="flex w-full h-12 items-center justify-center rounded-lg bg-blue-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-blue-600 focus:outline-none focus-visible:outline-none focus-visible:ring-0 focus-visible:shadow-none"
          @click="$emit('confirm')"
        >
          Confirm
        </button>
        <button
          type="button"
          class="flex h-12 w-24 items-center justify-center rounded-lg border border-slate-600 px-4 py-2 text-sm font-semibold text-slate-600 transition focus:outline-none focus-visible:outline-none focus-visible:ring-0 focus-visible:shadow-none"
          @click="$emit('cancel-confirm')"
        >
          Cancel
        </button>
      </div>
    </div>

    <form v-else @submit.prevent="handleSubmit">
      <div class="flex flex-col gap-4 mt-6">
        <CoreInputField
          id="subscription-id"
          label="Subscription ID"
          v-model="localForm.subscriptionId"
          :required="true"
          :error="errors.subscriptionId"
        />

        <CoreDropdown
          label="Select Plan"
          :options="planOptions"
          :value.sync="localForm.plan"
          :get-label="getPlanLabel"
          :get-value="getPlanValue"
          placeholder="Select plan"
          variant="simple"
          :required="true"
          :error="errors.plan"
        />

        <CoreDropdown
          label="Select Currency"
          :options="currencyOptions"
          :value.sync="localForm.currency"
          :get-label="getCurrencyLabel"
          :get-value="getCurrencyValue"
          placeholder="Select currency"
          variant="simple"
          :required="true"
          :error="errors.currency"
        />

        <CoreDropdown
          label="Select Billing Cycle"
          :options="billingCycleOptions"
          :value.sync="localForm.billingCycle"
          :get-label="getCycleLabel"
          :get-value="getCycleValue"
          placeholder="Select billing cycle"
          variant="simple"
          :required="true"
          :error="errors.billingCycle"
        />
      </div>

      <div class="flex justify-between items-center gap-3 mt-6">
        <button
          type="submit"
          class="flex items-center justify-center w-full h-12 rounded-lg bg-blue-500 px-4 py-2 text-sm font-semibold text-white transition hover:bg-blue-600 focus:outline-none focus-visible:outline-none focus-visible:ring-0 focus-visible:shadow-none"
        >
          Save
        </button>
        <button
          type="button"
          class="flex items-center justify-center w-24 h-12 rounded-lg px-4 py-2 text-sm font-semibold text-slate-600 border border-slate-600 transition  focus:outline-none focus-visible:outline-none focus-visible:ring-0 focus-visible:shadow-none"
          @click="$emit('cancel')"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Icon from "../core/Icon.vue";
import CoreInputField from "../core/InputField.vue";
import CoreDropdown from "../core/Dropdown.vue";

export default {
  name: "ChangeSubscriptionForm",
  components: {
    Icon,
    CoreInputField,
    CoreDropdown
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      required: true
    },
    isConfirming: {
      type: Boolean,
      default: false
    },
    planOptions: {
      type: Array,
      required: true
    },
    currencyOptions: {
      type: Array,
      required: true
    },
    billingCycleOptions: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      localForm: { ...this.value }
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(newVal) {
        this.localForm = { ...newVal };
      }
    }
  },
  methods: {
    getPlanLabel(option) {
      return option.label;
    },
    getPlanValue(option) {
      return option.value;
    },
    getCurrencyLabel(option) {
      return option.label;
    },
    getCurrencyValue(option) {
      return option.value;
    },
    getCycleLabel(option) {
      return option.label;
    },
    getCycleValue(option) {
      return option.value;
    },
    handleSubmit() {
      const payload = {
        subscriptionId: this.localForm.subscriptionId,
        plan: this.localForm.plan,
        currency: this.localForm.currency,
        billingCycle: this.localForm.billingCycle
      };
      this.$emit("save", payload);
    }
  }
};
</script>
